angular
  .module('shared')
  .filter 'responsiveTruncate', ->
    (text, customLimit) ->
      return text unless angular.isString(text)

      charLimit = customLimit

      unless charLimit?
        screenWidth = window.innerWidth
        if screenWidth <= 768
          charLimit = 20
        else if screenWidth <= 1366
          charLimit = 30
        else if screenWidth <= 1700
          charLimit = 45
        else
          charLimit = 75

      if text.length > charLimit
        text.slice(0, charLimit) + '…'
      else
        text
